<template>
    <div class="container">
        <div class="row">
            <div class="col-eight">
                <div class="panel panel-default">
                    <div class="panel-heading">Example Component</div>

                    <div class="panel-body">
                        I'm an example component!
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default { };
</script>
